/**
 * 隐患依据
 */

export const hazardBasisList = [
  {
    prop: "troubleDescribe",
    label: "隐患描述",
    width: "150",
    isShow: true,
  },
  {
    prop: "judgment",
    label: "判定依据",
    width: "150",
    isShow: true,
  },
  {
    prop: "industry",
    label: "适合行业",
    width: "200",
    isShow: true,
  },
  {
    prop: "intension",
    label: "依据强度",
    width: "200",
    isShow: true,
  },
  {
    prop: "level",
    label: "隐患等级",
    width: "200",
    isShow: true,
  },
  {
    prop: "creationTime",
    label: "创建时间",
    width: "150",
    isShow: true,
    format: "datetime",
  },
];
